import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "components/Router/routes/rootRoute";
import { gameMasterAppHeaderConfig } from "./gameMasterAppHeaderConfig";
import { LazyGameMaster, LazyGameMasters } from "./lazyGameMasterRoutes";

export const gameMasterRoute = createRoute({
  getParentRoute: () => rootRoute,
  component: LazyGameMasters,
  ...gameMasterAppHeaderConfig,
});

const specificGameMasterRoute = createRoute({
  getParentRoute: () => gameMasterRoute,
  component: LazyGameMaster,
  path: "$pageId",
  staticData: {
    label: "GM",
  },
});

gameMasterRoute.addChildren([specificGameMasterRoute]);
